import React, { Component } from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Sosyal Medya Yönetimi',
        description: 'Markanızı sosyal medyada etkili bir şekilde yönetir, hedef kitlenize ulaşmanızı sağlarız.',
        link: '/hizmetlerimiz/sosyal-medya-yonetimi'
    },
    {
        icon: <FiLayers />,
        title: 'Web Tasarım ve Geliştirme',
        description: 'SEO uyumlu, kullanıcı dostu ve mobil uyumlu web siteleri tasarlıyoruz.',
        link: '/hizmetlerimiz/web-tasarim'
    },
    {
        icon: <FiUsers />,
        title: 'Google Ads Danışmanlığı',
        description: 'Hedef kitlenize ulaşmanızı sağlayacak etkili Google Ads kampanyaları oluşturuyoruz.',
        link: '/hizmetlerimiz/google-ads-danismanligi'
    },
    {
        icon: <FiMonitor />,
        title: 'Kurumsal Kimlik Tasarımı',
        description: 'Markanızı tanımlayan etkili ve profesyonel bir kurumsal kimlik oluşturuyoruz.',
        link: '/hizmetlerimiz/kurumsal-kimlik-tasarimi'
    }
]

class ServiceTwo extends Component{
    render(){
        let title = 'Hizmetler',
        description = 'İşletmenizin dijital dünyada başarılı olması için sunduğumuz hizmetler.';
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="section-title mt--30 mt_md--5 mt_mobile--5 mb_mobile--10">
                            <h2 className="title">{title}</h2>
                            <p>{description}</p>
                            <div className="service-btn">
                                <a className="btn-transparent rn-btn-dark" href="/hizmetlerimiz"><span className="text">Tüm Hizmetlerimiz</span></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-12 mt_md--50">
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href={val.link}>
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceTwo;
